'use strict';

var Molecule = require('openchemlib').Molecule;

var fields = new Map();
module.exports = fields;

fields.set('oclid', Molecule.fromIDCode);
fields.set('idcode', Molecule.fromIDCode);
fields.set('smiles', Molecule.fromSmiles);
fields.set('molfile', Molecule.fromMolfile);



//////////////////
// WEBPACK FOOTER
// ./~/openchemlib-extended/src/db/moleculeCreator.js
// module id = 21
// module chunks = 0